import * as THREE from 'three';
import { MeshLineGeometry, MeshLineMaterial, raycast } from 'meshline'
export function createMeshFromLine(pointList, width) {
  var points_per = [];
  var points = [];
  pointList.forEach((e) => {
    points_per.push(new THREE.Vector3(e.x, e.y, 0));
  });
  points.push(points_per[0]);
  let p_init = points_per[0];
  for (let i = 1; i < points_per.length; i++) {
    let distance = points_per[i].distanceTo(p_init);
    if (distance > 0.05) {
      points.push(points_per[i]);
      p_init = points_per[i];
    }
  }

  // 创建顶点数组来存储顶点位置
  if (points.length < 2) {
    return [];
  }
  var vertices = [];
  {
    var previousPoint = points[1];
    var currentPoint = points[0];
    // var nextPoint = points[i + 1];

    // 计算当前点到前一个点的方向向量
    var direction = new THREE.Vector3()
      .subVectors(currentPoint, previousPoint)
      .normalize();

    // 计算当前点到下一个点的方向向量
    // var nextDirection = new THREE.Vector3().subVectors(nextPoint, currentPoint).normalize();

    // 计算垂直于当前方向的向量，作为左右两侧点的偏移方向
    var leftOffset = new THREE.Vector3(
      -direction.y,
      direction.x,
      0,
    ).normalize();
    var rightOffset = new THREE.Vector3(
      direction.y,
      -direction.x,
      0,
    ).normalize();

    // 根据宽度和偏移方向计算左侧和右侧点的位置
    var leftPoint = new THREE.Vector3()
      .copy(currentPoint)
      .addScaledVector(leftOffset, width * 0.5);
    var rightPoint = new THREE.Vector3()
      .copy(currentPoint)
      .addScaledVector(rightOffset, width * 0.5);

    // 添加左侧和右侧点的位置到顶点数组
    vertices.unshift(leftPoint);
    vertices.push(rightPoint);
  }

  for (var i = 1; i < points.length; i++) {
    var previousPoint = points[i - 1];
    var currentPoint = points[i];
    // var nextPoint = points[i + 1];

    // 计算当前点到前一个点的方向向量
    var direction = new THREE.Vector3()
      .subVectors(currentPoint, previousPoint)
      .normalize();

    // 计算当前点到下一个点的方向向量
    // var nextDirection = new THREE.Vector3().subVectors(nextPoint, currentPoint).normalize();

    // 计算垂直于当前方向的向量，作为左右两侧点的偏移方向
    var leftOffset = new THREE.Vector3(
      -direction.y,
      direction.x,
      0,
    ).normalize();
    var rightOffset = new THREE.Vector3(
      direction.y,
      -direction.x,
      0,
    ).normalize();

    // 根据宽度和偏移方向计算左侧和右侧点的位置
    var leftPoint = new THREE.Vector3()
      .copy(currentPoint)
      .addScaledVector(leftOffset, width * 0.5);
    var rightPoint = new THREE.Vector3()
      .copy(currentPoint)
      .addScaledVector(rightOffset, width * 0.5);

    // 添加左侧和右侧点的位置到顶点数组
    vertices.push(leftPoint);
    vertices.unshift(rightPoint);
  }

  // 创建缓冲几何体
  // var geometry = new THREE.BufferGeometry();
  // geometry.setAttribute('position', new THREE.Float32BufferAttribute(vertices, 3));

  // // 创建材质
  // var material = new THREE.MeshBasicMaterial({ color: 0xff0000 });

  // // 创建网格对象
  // var mesh = new THREE.Mesh(geometry, material);

  // 将网格对象添加到场景中
  return vertices;
}

//#region delete
export function createMeshFromLine2(pointList, width) {
  let vectorList = [];
  pointList.forEach((e) => {
    vectorList.push(new THREE.Vector3(e.x, e.y, 0));
  });
  const curve = new THREE.CatmullRomCurve3(vectorList);
  const points = curve.getPoints(100);
  // const line = new THREE.Line(
  //     new THREE.BufferGeometry().setFromPoints(points),
  //     new THREE.LineBasicMaterial({ color: 0x00ff00 })
  // );

  let tangentList = [];
  points.forEach((e, index) => {
    const tangent = curve.getTangentAt(index / 100);
    tangentList.push(tangent);
  });
  let points2 = get2(points, tangentList, width);
  // let heartShape = new THREE.Shape()
  // points2.forEach((e, index) => {
  //     if (index == 0) {
  //         heartShape.moveTo(e.x, e.y)
  //     } else {
  //         heartShape.lineTo(e.x, e.y)
  //     }
  // })
  // const geometry_shape = new THREE.ShapeGeometry(heartShape)
  // const material_shape = new THREE.MeshBasicMaterial({
  //     color: 0x1d953f,
  //     side: THREE.DoubleSide
  // })
  // const mesh = new THREE.Mesh(geometry_shape, material_shape)
  // mesh.position.set(0, 0, 5)
  // mesh.renderOrder = -10
  // return {
  //     line: mesh,
  //     points: points2
  // }
  return points2;
}
function get2(points, tangentList, width) {
  let newPoints = [];
  let new_tangentList = [];
  points.forEach((e) => {
    newPoints.push(new THREE.Vector3(e.x, e.y, e.z));
  });
  tangentList.forEach((e) => {
    new_tangentList.push(new THREE.Vector3(e.x, e.y, e.z));
  });
  for (let i = 0; i < points.length; i++) {
    tangentList[i].applyAxisAngle(new THREE.Vector3(0, 0, 1), -Math.PI / 2);
    points[i].addScaledVector(tangentList[i], width);
  }
  for (let i = 0; i < newPoints.length; i++) {
    new_tangentList[i].applyAxisAngle(new THREE.Vector3(0, 0, 1), Math.PI / 2);
    newPoints[i].addScaledVector(new_tangentList[i], width);
  }
  let result = [];
  for (let i = 0; i < newPoints.length; i++) {
    result.push(points[i]);
    result.unshift(newPoints[i]);
  }
  return result;
}
//#endregion


let material_m_1 = new MeshLineMaterial({
    color: new THREE.Color(0xffd400),
    lineWidth: 0.4,        // 大一点
    dashArray: 0.2,        // 总周期
    dashRatio: 0.4,        // 空段比例
    transparent: true,     // ⚠️ 透明才能看到间断
    opacity: 1.0,
})
let material_m_2 = new MeshLineMaterial({
    color: new THREE.Color(0xfffffb),
    lineWidth: 0.4,        // 大一点
    dashArray: 0.2,        // 总周期
    dashRatio: 0.4,        // 空段比例
    transparent: true,     // ⚠️ 透明才能看到间断
    opacity: 1.0,
})
let material_m_0 = new MeshLineMaterial({
    color: new THREE.Color(0x7c8577),
    lineWidth: 0.4,        // 大一点
    dashArray: 0.2,        // 总周期
    dashRatio: 0.4,        // 空段比例
    transparent: true,     // ⚠️ 透明才能看到间断
    opacity: 1.0,
})
let m_c = new MeshLineMaterial({
    color: new THREE.Color(0x7a1723),
    lineWidth: 0.4,        // 大一点
    dashArray: 0.2,        // 总周期
    dashRatio: 0.4,        // 空段比例
    transparent: true,     // ⚠️ 透明才能看到间断
    opacity: 1.0,
})

/** LocalMap 实线 boundary：无 dash，避免 Shape 填充闭合多边形成大色块 */
const solidMeshLineMaterialCache = new Map()

function getSolidMeshLineMaterial(colorHex) {
    const key = colorHex >>> 0
    if (!solidMeshLineMaterialCache.has(key)) {
        solidMeshLineMaterialCache.set(
            key,
            new MeshLineMaterial({
                color: new THREE.Color(key),
                lineWidth: 0.35,
                transparent: true,
                opacity: 1.0,
            }),
        )
    }
    return solidMeshLineMaterialCache.get(key)
}

export function createSolidMeshLine(points, colorHex = 0xf0dc70) {
    const pointList = points.map((p) => new THREE.Vector3(p.x, p.y, 0))
    if (pointList.length < 2) return null
    const geometry = new MeshLineGeometry()
    geometry.setPoints(pointList)
    const material = getSolidMeshLineMaterial(colorHex)
    const mesh = new THREE.Mesh(geometry, material)
    mesh.raycast = raycast
    mesh.mouseMaterial = m_c
    return mesh
}

export function createDashedMeshLine(points, color=0) {
    // const geometry = new THREE.BufferGeometry().setFromPoints(points.map(p => new THREE.Vector3(p.x, p.y, 0.5)));
    // const material = m
    // const line = new THREE.Line(geometry, material);
    // line.computeLineDistances();
    // line.mouseMaterial=m_c
    // return line;
    let pointList = points.map(p => new THREE.Vector3(p.x, p.y, 0))

    // 几何体
    const geometry = new MeshLineGeometry()
    geometry.setPoints(pointList)

    // material_m.resolution = new THREE.Vector2(window.innerWidth, window.innerHeight)
    let material=getMaterial_m(color);
    const mesh = new THREE.Mesh(geometry, material)
    mesh.raycast = raycast // 否则不支持拾取
    mesh.mouseMaterial = m_c
    return mesh;

}

function getMaterial_m(color) {
    let m = material_m_0
    switch (color) {
        case 1:
            m = material_m_1
            break;
        case 2:
            m = material_m_2
            break;
        default:
            break;
    }
    return m;
}